/*****************************************************
 * Packages
 ******************************************************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/*****************************************************
 * Local
 ******************************************************/
import { inputField } from './reusable/shared-styles';
import isArray from '../../util/isArray';

/*****************************************************
 * Styles
 ******************************************************/
const SelectWrap = styled.div`
    position: relative;
`;
const SelectEl = styled.div`
    display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
    justify-content: space-between;
    align-items: center;
    position: relative;
    cursor: pointer;
    ${inputField}
    /* should be after inputField */
    ${({ isExpended }) =>
        isExpended &&
        `border-bottom-right-radius: 0;
        border-bottom-left-radius: 0; 
        border-bottom: 0;`}

    .select-arrow {
        position: absolute;
        right: 15px;
    }
`;

const OptionEl = styled.li`
    color: ${({ theme, isActive }) =>
        isActive ? theme.primary.fg : theme.bodyText};
    padding: 0 15px 0 38px;
    align-items: center;
    position: relative;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    height: 40px;

    .icon {
        position: absolute;
        left: 15px;
    }

    &:last-child {
        border-radius: 0 0 5px 5px;
    }

    &:hover {
        background-color: ${({ theme }) => theme.primary.fg};
        color: ${({ theme }) => theme.primary.bg};
    }
`;

const OptionWrap = styled.ul`
    border: 1px solid ${({ theme }) => theme.inputBorder};
    background: ${({ theme }) => theme.primary.bg};
    border-radius: 0 0 5px 5px;
    position: absolute;
    list-style: none;
    width: 100%;
    padding: 0;
    z-index: 1;
    top: 100%;
    margin: 0;
`;

const SelectNative = styled.select`
    ${inputField}
    height: 40px;
    width: 100%;

    &:focus {
        outline: 0;
        border-color: #80bdff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25) inset;
    }
`;

export const Option = (props) => {
    const { children, selected, value, handleSelect, disabled } = props;
    // const isActive = value === selected;
    // const handleClick = e => {
    //     e.stopPropagation();
    //     handleSelect(value);
    // };
    return (
        // <OptionEl onClick={handleClick} isActive={isActive}>
        //     {isActive && (
        //         <FontAwesomeIcon className="icon" icon="check" fixedWidth />
        //     )}
        //     {children}
        // </OptionEl>
        <option value={value} disabled={disabled}>
            {children}
        </option>
    );
};

const Select = (props) => {
    const { children, onSelect, name, selected, ...rest } = props;
    // let selectedItem;
    // if (!isArray(children)) {
    //     selectedItem = children.props.value === selected && children.props;
    // }
    // selectedItem = children.find(child => child.props.value === selected);
    // selectedItem = selectedItem
    //     ? selectedItem.props
    //     : { value: '', children: '' };

    // const [isVisible, setVisibility] = useState(false);
    const handleSelect = (e) => {
        const result = { name, value: e.target.value };
        onSelect && onSelect(result);
        // setVisibility(false);
    };
    return (
        <SelectNative value={selected} onChange={handleSelect} {...rest}>
            {children}
        </SelectNative>
        // <SelectWrap>
        //     <SelectEl
        //         isExpended={isVisible}
        //         onClick={() => setVisibility(!isVisible)}
        //     >
        //         {selectedItem.children}
        //         <FontAwesomeIcon
        //             className="select-arrow"
        //             icon={isVisible ? 'chevron-up' : 'chevron-down'}
        //         />
        //     </SelectEl>
        //     {isVisible && (
        //         <OptionWrap>
        //             {React.Children.map(children, child =>
        //                 React.cloneElement(child, { handleSelect, selected })
        //             )}
        //         </OptionWrap>
        //     )}
        // </SelectWrap>
    );
};

Select.propTypes = {
    onSelect: PropTypes.func.isRequired,
};

export default React.memo(Select);
